import { DataTableSortStatus } from "mantine-datatable";

import {
  CustomerOrderBy,
  LimitRequestOrderBy,
  OrderBy,
} from "../../graphql/generated.ts";
import { getApiOrderBy } from "../../utils/api.ts";

export const getLimitRequestApiSort = (
  tableSort: DataTableSortStatus
): LimitRequestOrderBy => {
  const { companyName, salesName, salesTeamName, ...apiSort } =
    getApiOrderBy(tableSort);
  let company: CustomerOrderBy | undefined = undefined;
  if (companyName) {
    company = { name: companyName };
  }
  if (salesName) {
    company = { salesName };
  }
  if (salesTeamName) {
    company = { salesTeamName };
  }
  const formattedApiSort: LimitRequestOrderBy = {
    company,
  };
  Object.keys(apiSort).map((key) => {
    if (!key.includes(".")) {
      formattedApiSort[key as keyof LimitRequestOrderBy] = apiSort[
        key
      ] as OrderBy;
      return;
    }
    const [tableKey, fieldKey] = key.split(".");
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    formattedApiSort[tableKey] = {
      [fieldKey]: apiSort[key] as OrderBy,
    };
  });
  return formattedApiSort;
};
